var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height-anime-container"},[_c('Transition',{attrs:{"css":false},on:{"leave":_vm.leave,"enter":_vm.enter,"afterEnter":_vm.afterEnter,"beforeLeave":_vm.beforeLeave}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }